<template>
  <div class="card shadow mb-4">
    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
      <h6 class="m-0 font-weight-bold">{{ $t('Production_and_Consumption') }}</h6>
      <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="top" :title="$t('comparison_tooltip_prod_cons')"></i>
    </div>
    <div class="card-body text-center">
      <LoadingSpinner v-if="loading"></LoadingSpinner>
      <div v-show="!loading" id="canvas-productionconsumption"></div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from './LoadingSpinner.vue'

export default {
  name: 'ProdConsBars',
  components: {
    LoadingSpinner
  },
  data(){
    return {
      chart: null,
    }
  },
  mounted: function(){
    const self = this
    this.chart = Highcharts.chart('canvas-productionconsumption', {
        chart: {
          type: 'bar',
          height: 250,
          backgroundColor: '#fff'
        },
        credits: { enabled: false },
        title: {
          text: ''
        },
        subtitle: {
          text: ''
        },
        xAxis: [{
          categories: [],
          reversed: false,
          labels: {
              step: 1
          }, tickPixelInterval: 10
        }],
        yAxis: {
          title: {
            text: null
          },
          labels: {
            formatter: function () {
              return Math.abs(this.value);
            }
          },
        },
        plotOptions: {
            series: {
              stacking: 'normal',
              groupPadding: 0,
              maxPointWidth: 40,
              dataLabels: {
                style: { 
                    fontSize: '14px',
                    textOutline: '0px contrast'
                },
                enabled: true,
                color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'black',
                formatter: function() 
                {
                  return Math.abs(this.y).toFixed(2)
                }
              },
              events: {
                legendItemClick: function () {
                    if(this.visible) _paq.push(['trackEvent', 'Comparação', 'Gráfico Produção vs Consumo', 'Esconder (' + this.name + ')'])                        
                    else _paq.push(['trackEvent', 'Comparação', 'Gráfico Produção vs Consumo', 'Mostrar (' + this.name + ')'])
                },
                mouseOver: function () {
                  self.clock = setInterval(function(){ self.sec++;  }, 1000)
                },
                mouseOut: function () {
                    clearInterval(self.clock);
                    if (self.sec > 1) _paq.push(['trackEvent', 'Comparação', 'Gráfico Produção vs Consumo', 'MouseOver (' + this.name + ')', self.sec])
                    self.sec = 0
                }
              }
            }
        },
        tooltip: {
          shared: true,
          pointFormatter: function () 
          {
            return '<span style="color:' + this.series.color + '">\u25CF</span> ' + this.series.name + ': <b>' + Math.abs(this.y).toFixed(2) + ' kWh</b><br/>';
          }
        },
        exporting: false,
        series: [{
            name: this.$i18n.t('Production'),
            data: [],
            color: '#4187c7',
            stack: 'normal'
        }, 
        {
            name: this.$i18n.t('Consumption'),
            data: [],
            color: '#f7882f',
            stack: 'normal'
        }]
    })
  },
  methods: {
    set_values: function(){
      let legend1 = ""
      let legend2 = ""
      const datetime1 = moment(this.datetime1)
      const datetime2 = moment(this.datetime2)
      const timezone = this.$store.getters.timezone
      let datetimeUTC = moment.tz(datetime1.format('YYYY-MM-DD'), timezone).toJSON()
      let datetimeUTC2 = moment.tz(datetime2.format('YYYY-MM-DD'), timezone).toJSON()

      if (this.range == 'day'){
        legend1 = moment(datetime1).format('DD MMM YYYY')
        legend2 = moment(datetime2).format('DD MMM YYYY')
      } 
      else if (this.range == 'week') {
        legend1 = moment(datetime1).format('DD') +'-' + moment(datetime1).add(6, "days").format('DD MMM YYYY')
        legend2 = moment(datetime2).format('DD') +'-' + moment(datetime2).add(6, "days").format('DD MMM YYYY')
      }
      else if (this.range == 'month'){
        legend1 = moment(datetime1).format('MMM YYYY')
        legend2 = moment(datetime2).format('MMM YYYY')
      }

      let produced = []
      produced.push(this.data[0].PV_Batt + this.data[0].PV_Grid + this.data[0].PV_House)
      produced.push(this.data[1].PV_Batt + this.data[1].PV_Grid + this.data[1].PV_House)

      let consumed = []
      consumed.push(this.data[0].Batt_House + this.data[0].PV_House + this.data[0].Grid_House)
      consumed.push(this.data[1].Batt_House + this.data[1].PV_House + this.data[1].Grid_House)

      this.chart.xAxis[0].setCategories([legend2, legend1])
      /* this.chart.series[0].setData([-this.data[1].produced, -this.data[0].produced], false)
      this.chart.series[1].setData([this.data[1].consumed, this.data[0].consumed], false) */
      this.chart.series[0].setData([-produced[1], -produced[0]], false)
      this.chart.series[1].setData([consumed[1], consumed[0]], false)

      if(!this.chart.hasData()){
        this.chart.hideNoData()
        this.chart.showNoData(this.$i18n.t("No_Data"))
      }
      this.chart.redraw()
    }
  },
  watch: {
    data: function(){
      this.set_values()
    },
    current_lang: function(){
      this.chart.series[0].update({name: this.$i18n.t('Consumption')}, false);
      this.chart.series[1].update({name: this.$i18n.t('Production')}, false);
      this.set_values()
    }
  },
  computed: {
    data: function(){
      return this.$store.getters.data_energyUsed_comparison
    },
    range: function(){
      return this.$store.getters.selected_range
    },
    datetime1: function(){
      return this.$store.getters.datetime1
    },
    datetime2: function(){
      return this.$store.getters.datetime2
    },
    loading: function(){
      return this.$store.getters.data_loading
    },
    current_lang: function(){
      return this.$i18n.locale
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
